module.exports = __webpack_public_path__ + "img/rad-dig-sala-config-2.943dd591.png";